function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#000000;stroke-width:24;stroke-linecap:round;stroke-linejoin:round;}\n");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "st0",
  width: 256,
  height: 256
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 216,
  y1: 56,
  x2: 40,
  y2: 56
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 104,
  y1: 104,
  x2: 104,
  y2: 168
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 152,
  y1: 104,
  x2: 152,
  y2: 168
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M200,56v152c0,4.4-3.6,8-8,8H64c-4.4,0-8-3.6-8-8V56"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M168,56V40c0-8.8-7.2-16-16-16h-48c-8.8,0-16,7.2-16,16v16"
});

function SvgTrashBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raw",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBold);
export default __webpack_public_path__ + "static/media/trash-bold.65d07263.svg";
export { ForwardRef as ReactComponent };